import { storage } from '@/utils/api';
import { createRouter, createWebHistory } from 'vue-router'

const onlyAuth = [
  'TradingTerminal',
  'Multiplier',
  'ChangesList',
  'TransactionHistory',
];

const adminRoutes = [
  'AdminDashboard',
  'AdminUsers',
  'AdminAddresses',
  'AdminTransactions',
  'AdminReferrals',
  'AdminSettings',
];

const routes = [
  {
    path: '/',
    name: 'Index',
    component: () => import(/* webpackChunkName: "MainView" */ '../views/MainView.vue'),
    children: [
      {
        path: '',
        name: 'Landing',
        component: () => import('../pages/Landing/LandingPage.vue')
      },
      {
        path: '/subscription/success',
        component: () => import('../pages/Subscription/Success.vue')
      },
      {
        path: '/trading',
        name: 'Trading',
        children: [
          {
            path: '',
            name: 'TradingTerminal',
            component: () => import(/* webpackChunkName: "TradingTerminal" */ '../pages/Trading/TradingTerminal.vue'),
          }
        ]
      },
      {
        path: '/transactions',
        name: 'ChangesList',
        component: () => import(/* webpackChunkName: "ChangesList" */ '../pages/Plaid/ChangesList/ChangesListContainer.vue'),
      },
      {
        path: '/transaction-history',
        name: 'TransactionHistory',
        component: () => import(/* webpackChunkName: "TransactionHistory" */ '../pages/Transactions/TransactionsPage.vue'),
      },
      {
        path: '/linked-accounts',
        name: 'LinkedAccounts',
        component: () => import(/* webpackChunkName: "LinkedAccounts" */ '../pages/Profile/LinkedAccounts.vue'),
      },
      {
        path: '/address',
        name: 'DepositAddress',
        component: () => import(/* webpackChunkName: "DepositAddress" */ '../pages/Deposit/DepositAddress.vue'),
      },
      {
        path: '/balances',
        name: 'BalancesList',
        component: () => import(/* webpackChunkName: "BalancesList" */ '../pages/BalancesList/BalancesList.vue'),
      },
      {
        path: '/withdraw',
        name: 'Withdraw',
        component: () => import(/* webpackChunkName: "Withdraw" */ '../pages/Withdraw/WithdrawPage.vue'),
      },
      {
        path: '/swap',
        name: 'Swap',
        component: () => import(/* webpackChunkName: "Swap" */ '../pages/Swap/SwapPage.vue'),
      },
      {
        path: '/multiplier',
        name: 'Multiplier',
        component: () => import(/* webpackChunkName: "Multiplier" */ '../pages/Trading/MultiplierPage.vue'),
      },
      {
        path: '/referrals',
        name: 'Referrals',
        component: () => import(/* webpackChunkName: "Referrals" */ '../pages/Referrals/ReferralsPage.vue'),
      },
      {
        path: '/login',
        name: 'Login',
        children: [
          {
            path: '',
            name: 'LoginPage',
            component: () => import(/* webpackChunkName: "LoginPage" */ '../pages/Login/LoginPage.vue'),
          }
        ]
      },
      {
        path: '/reset-password',
        name: 'ResetPassword',
        children: [
          {
            path: '',
            name: 'ResetPasswordPage',
            component: () => import(/* webpackChunkName: "ResetPasswordPage" */ '../pages/Login/ResetPasswordPage.vue'),
          }
        ]
      },
      {
        path: '/registration',
        name: 'Register',
        props: true,
        children: [
          {
            path: '',
            name: 'RegisterPage',
            props: true,
            component: () => import(/* webpackChunkName: "RegisterPage" */ '../pages/Register/RegisterPage.vue'),
          }
        ]
      },
      {
        path: '/registration',
        name: 'Registration',
        props: true,
        children: [
          {
            path: '',
            name: 'RegistrationPage',
            props: true,
            component: () => import(/* webpackChunkName: "RegisterPage" */ '../pages/Register/RegisterPage.vue'),
          }
        ]
      },
    ]
  },
  {
    path: '/confirmation-code/:type/:payload',
    name: 'ConfirmationCode',
    component: () => import(/* webpackChunkName: "ConfirmationCode" */ '../pages/ConfirmationCode.vue'),
    props: true,
  },
  {
    path: '/admin',
    redirect: '/admin/dashboard',
  },
  {
    path: '/admin/dashboard',
    name: 'AdminDashboard',
    component: () => import(/* webpackChunkName: "AdminDashboard" */ '../pages/Admin/AdminUsersPage.vue'),
  },
  {
    path: '/admin/users',
    name: 'AdminUsers',
    component: () => import(/* webpackChunkName: "AdminUsers" */ '../pages/Admin/AdminUsersPage.vue'),
  },
  {
    path: '/admin/addresses',
    name: 'AdminAddresses',
    component: () => import(/* webpackChunkName: "AdminAddresses" */ '../pages/Admin/AdminAddressesPage.vue'),
  },
  {
    path: '/admin/transactions',
    name: 'AdminTransactions',
    component: () => import(/* webpackChunkName: "AdminTransactions" */ '../pages/Admin/AdminUsersPage.vue'),
  },
  {
    path: '/admin/referrals',
    name: 'AdminReferrals',
    component: () => import(/* webpackChunkName: "AdminReferrals" */ '../pages/Admin/AdminUsersPage.vue'),
  },
  {
    path: '/admin/settings',
    name: 'AdminSettings',
    component: () => import(/* webpackChunkName: "AdminSettings" */ '../pages/Admin/AdminUsersPage.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const routeName = to.name;
  if (!routeName || typeof routeName !== 'string') return next();
  if (checkIsAuthRequired(routeName) && !storage.isLoggedIn()) return next({ name: 'LoginPage' })
  if (routeName === 'Landing' && storage.isLoggedIn()) return next({ name: 'TradingTerminal' })
  return next();
})


export default router

export const checkIsAuthRequired = (routeName: string | symbol | undefined | null) => {
  if (!routeName || typeof routeName !== 'string') return;
  return onlyAuth.includes(routeName);
}

export const checkIsAdminRoute = (routeName: string | symbol | undefined | null) => {
  if (!routeName || typeof routeName !== 'string') return false;
  return adminRoutes.includes(routeName);
}